export default __webpack_public_path__ + "static/media/left.f73dccdc.svg";